'use client'

import React, { useTransition } from 'react'
import { Button, toast, useTranslation } from '@payloadcms/ui'
import { RefreshCcw, RefreshCwOffIcon, RotateCcw } from 'lucide-react'

export function RefreshPropertyButtonClient({
  onRefresh,
  onReset,
  lang,
}: {
  onRefresh: () => Promise<void>
  onReset: () => Promise<void>
  lang: string
}) {
  const [isPending, startTransition] = useTransition()
  const {} = useTranslation()

  const refreshingText =
    lang === 'en' ? 'Refreshing...' : lang === 'fr' ? 'Mise à jour...' : 'التحديث...'
  const refreshText = lang === 'en' ? 'Refresh' : lang === 'fr' ? 'Actualiser' : 'تحديث'
  const successText =
    lang === 'en'
      ? 'Listing refreshed successfully!'
      : lang === 'fr'
        ? 'Annonce mise à jour avec succès !'
        : 'تم تحديث الإعلان بنجاح!'
  const errorText =
    lang === 'en'
      ? 'Failed to refresh listing.'
      : lang === 'fr'
        ? "Échec de la mise à jour de l'annonce."
        : 'فشل في تحديث الإعلان.'

  const resetText =
    lang === 'en' ? 'Reset refresh' : lang === 'fr' ? 'Réinitialiser' : 'إلغاء التحديث'
  const resettingText =
    lang === 'en' ? 'Resetting...' : lang === 'fr' ? 'Réinitialisation...' : 'جارٍ الإلغاء...'

  const successResetText =
    lang === 'en'
      ? 'Refresh date cleared.'
      : lang === 'fr'
        ? 'Date de mise à jour supprimée.'
        : 'تم حذف تاريخ التحديث.'

  const errorResetText =
    lang === 'en'
      ? 'Failed to reset refresh.'
      : lang === 'fr'
        ? 'Échec de la réinitialisation.'
        : 'فشل في إلغاء التحديث.'

  return (
    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
      <Button
        className="refresh-property-button"
        icon={isPending ? <RefreshCcw /> : <RefreshCwOffIcon />}
        size="small"
        disabled={isPending}
        onClick={() => {
          startTransition(async () => {
            try {
              await onRefresh()
              toast.success(successText)
              location.reload()
            } catch (error) {
              console.error(error)
              toast.error(errorText)
            }
          })
        }}
      >
        {isPending ? refreshingText : refreshText}
      </Button>
      <Button
        className="reset-refresh-property-button"
        icon={<RotateCcw />}
        size="small"
        buttonStyle="secondary"
        disabled={isPending}
        onClick={() => {
          startTransition(async () => {
            try {
              await onReset()
              toast.success(successResetText)
              location.reload()
            } catch (error) {
              console.error(error)
              toast.error(errorResetText)
            }
          })
        }}
      >
        {isPending ? resettingText : resetText}
      </Button>
    </div>
  )
}
